const generateActionType = (namespace, type) => `${namespace}/${type}`;

function* sequenceSagaEffect(tasks) {
  const results = [];

  /* eslint-disable no-restricted-syntax */
  for (const task of tasks) {
    const result = yield task;
    results.push(result);
  }
  /* eslint-enable no-restricted-syntax */

  return results;
}

export default {
  generateActionType,
  sequenceSagaEffect,
};
